// extracted by mini-css-extract-plugin
export var footer = "index-module--footer--uojx8";
export var logo = "index-module--logo--NayvD";
export var navLinks = "index-module--navLinks--NMx2B";